import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
export function PrivacyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] pt-20 sm:pt-24" data-id="element-405" data-mp="2o1lrlvn7yv55">
      <section className="page-header" data-id="element-406" data-mp="2s01jody5qtpf">
        <div className="container mx-auto max-w-6xl px-6 md:px-12" data-id="element-407" data-mp="2s378rt6sdvl5">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.26,
          ease: [0.23, 1, 0.32, 1]
        }} className="grid gap-8 lg:grid-cols-[1fr_auto] lg:items-end" data-id="element-408" data-mp="2x0z5r1mag7w7">
            <div className="max-w-3xl" data-id="element-409" data-mp="3fpm656tis93g">
              <p className="eyebrow" data-id="element-410" data-mp="3fsrycuxg3r3e">Información legal</p>
              <h1 className="mt-5 text-4xl font-medium tracking-[-0.055em] text-white sm:text-6xl" data-id="element-411" data-mp="3kqth1eqyloec">
                Política de Privacidad
              </h1>
            </div>
            <p className="border-l border-white/15 pl-5 text-xs leading-relaxed text-neutral-400 lg:max-w-[185px]" data-id="element-412" data-mp="2yqwriwni12gf">
              Última actualización:{' '}
              {new Date().toLocaleDateString('es-ES', {
              month: 'long',
              year: 'numeric'
            })}
            </p>
          </motion.div>
        </div>
      </section>

      <section className="section-shell border-b border-white/10" data-id="element-413" data-mp="2ksp0t6h22xdp">
        <div className="container mx-auto max-w-5xl px-6 md:px-12" data-id="element-414" data-mp="3hfl9paulktoi">
          <motion.article initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.26,
          delay: 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="mx-auto max-w-3xl border-x border-t border-white/10" aria-label="Contenido de la política de privacidad" data-id="element-415" data-mp="3derlshh5nevm">
            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-416" data-mp="j59tulkkd066">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-417" data-mp="o437qf3rit6v">
                1. Responsable del tratamiento
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-418" data-mp="abwryu4iuo7y">
                Growthly Corporation Systems es el responsable del tratamiento
                de los datos
                personales del Usuario y le informa que estos datos serán
                tratados de conformidad con lo dispuesto en el Reglamento (UE)
                2016/679 de 27 de abril de 2016 (GDPR) y la Ley Orgánica 3/2018
                de 5 de diciembre (LOPDGDD).
              </p>
              <ul className="mt-5 space-y-2.5 border-l border-white/15 pl-4 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-419" data-mp="3rluthbrb2gwm">
                <li data-id="element-420" data-mp="1lpqsu3urpp33">
                  <strong className="font-medium text-white" data-id="element-421" data-mp="1ptgd4h4etkib">Identidad:</strong>{' '}
                  Growthly Corporation Systems
                </li>
                <li data-id="element-422" data-mp="3acae7qfk1yy1">
                  <strong className="font-medium text-white" data-id="element-423" data-mp="3a9ejeaz07qdt">Teléfono:</strong>{' '}
                  +34 631 01 25 92
                </li>
                <li data-id="element-424" data-mp="3k1u1d8aaweyp">
                  <strong className="font-medium text-white" data-id="element-425" data-mp="3k2c3umnk3pf2">
                    Correo electrónico:
                  </strong>{' '}
                  hola@growthly.com
                </li>
              </ul>
              <p className="mt-5 border border-white/15 px-4 py-3 text-xs leading-relaxed text-neutral-300 sm:text-sm" data-id="element-426" data-mp="3ty5d9x5zb2sm">
                Nota interna: el teléfono y el correo electrónico indicados
                están pendientes de confirmación por parte de Growthly
                Corporation Systems antes de la publicación definitiva.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-427" data-mp="28lc455yvq8b0">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-428" data-mp="23nkbg9qeui5r">
                2. Datos que recogemos
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-429" data-mp="2615xurmsm5ra">
                Recopilamos los datos estrictamente necesarios para el correcto
                desarrollo de nuestra actividad y la prestación de nuestros
                servicios. Estos datos incluyen:
              </p>
              <ul className="mt-5 space-y-3 border-l border-white/15 pl-4 text-sm leading-relaxed text-neutral-400 sm:text-[15px]" data-id="element-430" data-mp="2k0p4ffzyh91h">
                <li data-id="element-431" data-mp="1rcjl8xojvs3r">Datos identificativos: nombre y apellidos.</li>
                <li data-id="element-432" data-mp="1raqcncudmxt4">
                  Datos de contacto: dirección de correo electrónico y número de
                  teléfono.
                </li>
                <li data-id="element-433" data-mp="212w32i4zd767">
                  Datos de navegación: dirección IP, comportamiento en la web
                  (mediante cookies).
                </li>
              </ul>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-434" data-mp="18ljr7i277s3m">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-435" data-mp="113c4kqk2m4c4">
                3. Finalidad del tratamiento
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-436" data-mp="w491hbnni86s">
                Los datos personales proporcionados serán utilizados para las
                siguientes finalidades:
              </p>
              <ul className="mt-5 space-y-3 border-l border-white/15 pl-4 text-sm leading-relaxed text-neutral-400 sm:text-[15px]" data-id="element-437" data-mp="m7w3w2ozja6r">
                <li data-id="element-438" data-mp="dcya6te0jted">
                  Gestionar la contratación de nuestros servicios de diseño y
                  desarrollo web.
                </li>
                <li data-id="element-439" data-mp="8c0uqoke1dgk">
                  Responder a consultas, solicitudes o peticiones realizadas a
                  través de los canales de contacto.
                </li>
                <li data-id="element-440" data-mp="3uktoszuxy92j">
                  Enviar comunicaciones comerciales sobre nuestros servicios
                  (solo si se ha dado el consentimiento expreso).
                </li>
                <li data-id="element-441" data-mp="3fxl5tcve4zg0">
                  Mejorar la experiencia de usuario en nuestra página web.
                </li>
              </ul>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-442" data-mp="36xy6qxq4w5q4">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-443" data-mp="370avpuub7gco">
                4. Base legal
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-444" data-mp="3gprmlmsjjz3">
                La base legal para el tratamiento de sus datos es la ejecución
                de un contrato (en caso de contratación de servicios), el
                consentimiento del interesado (para el envío de comunicaciones
                comerciales y el uso de cookies no técnicas) y el interés
                legítimo (para responder a consultas y mejorar nuestra web).
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-445" data-mp="r7vh7sij9qml">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-446" data-mp="10l423ahs7xka">
                5. Conservación de los datos
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-447" data-mp="wjs8ktvses6t">
                Los datos se conservarán durante el tiempo necesario para
                cumplir con la finalidad para la que se recabaron y para
                determinar las posibles responsabilidades que se pudieran
                derivar de dicha finalidad y del tratamiento de los datos,
                además de los periodos establecidos en la normativa de archivos
                y documentación.
              </p>
            </section>

            <section className="border-b border-white/10 px-6 py-8 sm:px-10 sm:py-10" data-id="element-448" data-mp="mm49jrr5eyiu">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-449" data-mp="230474w2iuc2x">
                6. Derechos del usuario
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-450" data-mp="1xzyepdofgljs">
                Como usuario, tiene derecho a:
              </p>
              <ul className="mt-5 space-y-3 border-l border-white/15 pl-4 text-sm leading-relaxed text-neutral-400 sm:text-[15px]" data-id="element-451" data-mp="dfdouq59gjw">
                <li data-id="element-452" data-mp="5ca86txh4tju">Acceder a sus datos personales.</li>
                <li data-id="element-453" data-mp="5ap9qt81gqgp">Solicitar la rectificación de los datos inexactos.</li>
                <li data-id="element-454" data-mp="a4jqbnsckpbk">
                  Solicitar su supresión cuando, entre otros motivos, los datos
                  ya no sean necesarios para los fines que fueron recogidos.
                </li>
                <li data-id="element-455" data-mp="jzlgmmyczxfq">Solicitar la limitación del tratamiento de sus datos.</li>
                <li data-id="element-456" data-mp="o4bc4ap3va04">Oponerse al tratamiento de sus datos.</li>
                <li data-id="element-457" data-mp="t1uo13ybzaow">Solicitar la portabilidad de sus datos.</li>
              </ul>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-458" data-mp="szqnmvzn4ttd">
                Puede ejercer estos derechos enviando un correo electrónico a
                hola@growthly.com.
              </p>
            </section>

            <section className="px-6 py-8 sm:px-10 sm:py-10" data-id="element-459" data-mp="2nb06p2m31wtz">
              <h2 className="text-xl font-medium tracking-[-0.025em] text-white" data-id="element-460" data-mp="2ij8fcpv3rn2s">
                7. Política de Cookies
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-neutral-300 sm:text-[15px]" data-id="element-461" data-mp="2dl6v41lxxhpq">
                Esta página web utiliza cookies técnicas necesarias para su
                funcionamiento. También podemos utilizar cookies analíticas para
                entender cómo los usuarios interactúan con el sitio web. Puede
                configurar su navegador para rechazar todas las cookies o para
                que le avise cuando se envíe una cookie.
              </p>
            </section>
          </motion.article>
        </div>
      </section>
    </div>;
}